import commercialRentImage from "./assets/commercial-rent.jpg";
import newBuildingsImage from "./assets/new-buildings.jpg";
import rentImage from "./assets/rent.jpg";
import { Link } from "react-router-dom";
import buyImage from "./assets/buy.jpg";
import React from "react";
import "./styles.css";

const categories = [
  {
    eyebrow: "От застройщика",
    title: "Новостройки",
    description: "Квартиры в новых жилых комплексах",
    to: "/housings",
    image: newBuildingsImage,
    accent: "mint",
  },
  {
    eyebrow: "Покупка по переуступке",
    title: "Переуступки",
    description: "Квартиры, коммерция и парковочные места",
    to: "/classifieds?market=sale&category=assignments",
    image: rentImage,
    accent: "slate",
  },
  {
    eyebrow: "Жилая недвижимость",
    title: "Купить / снять",
    description: "Квартиры и дома для покупки и аренды",
    to: "/classifieds",
    image: buyImage,
    accent: "orange",
  },
  {
    eyebrow: "Для бизнеса",
    title: "Коммерция",
    description: "Офисы, торговые и свободные площади",
    to: "/classifieds?market=rent&category=commercial",
    image: commercialRentImage,
    accent: "cyan",
  },
];

const handlePointerMove = (event: React.PointerEvent<HTMLAnchorElement>) => {
  const card = event.currentTarget;
  const bounds = card.getBoundingClientRect();
  const horizontal = (event.clientX - bounds.left) / bounds.width - 0.5;
  const vertical = (event.clientY - bounds.top) / bounds.height - 0.5;

  card.style.setProperty("--card-rotate-x", `${vertical * -5}deg`);
  card.style.setProperty("--card-rotate-y", `${horizontal * 7}deg`);
  card.style.setProperty("--glow-x", `${(horizontal + 0.5) * 100}%`);
  card.style.setProperty("--glow-y", `${(vertical + 0.5) * 100}%`);
};

const resetCardPosition = (event: React.PointerEvent<HTMLAnchorElement>) => {
  const card = event.currentTarget;
  card.style.setProperty("--card-rotate-x", "0deg");
  card.style.setProperty("--card-rotate-y", "0deg");
  card.style.setProperty("--glow-x", "50%");
  card.style.setProperty("--glow-y", "50%");
};

export const PublicHome = () => {
  return (
    <main className="public-home">
      <div className="public-home__intro">
        <p className="public-home__kicker">Недвижимость в одном месте</p>
        <p className="public-home__lead">
          Выберите направление — мы покажем подходящие объекты.
        </p>
      </div>

      <nav className="public-home__grid" aria-label="Разделы недвижимости">
        {categories.map((category, index) => (
          <Link
            className={`public-home-card public-home-card--${category.accent}`}
            to={category.to}
            key={category.title}
            onPointerMove={handlePointerMove}
            onPointerLeave={resetCardPosition}
            style={{ "--card-index": index } as React.CSSProperties}
          >
            <img
              className="public-home-card__image"
              src={category.image}
              alt=""
              aria-hidden="true"
            />
            <div className="public-home-card__wash" aria-hidden="true" />

            <div className="public-home-card__content">
              <p className="public-home-card__eyebrow">{category.eyebrow}</p>
              <h2>{category.title}</h2>
              <p className="public-home-card__description">
                {category.description}
              </p>
            </div>
          </Link>
        ))}
      </nav>
    </main>
  );
};
